import Notifications from '../SuperAdmin/Notifications';
export default Notifications;
